import DesarrolloHumano from  './DesarrolloHumano';

export default DesarrolloHumano;